import { ProductInfoSuggestAddCart } from './product-info-suggest-add-cart'
import { ProductInfoSuggestGallery } from './product-info-suggest-gallery'
import { ProductInfoSuggestItem } from './product-info-suggest-item'
import { ProductInfoSuggestModal } from './product-info-suggest-modal'
import { ProductInfoSuggestSizes } from './product-info-suggest-sizes'
import { ProductInfoSuggestVariants } from './product-info-suggest-variants'

export const ProductInfoSuggest = {
  Modal: ProductInfoSuggestModal,
  Item: ProductInfoSuggestItem,
  Variants: ProductInfoSuggestVariants,
  Sizes: ProductInfoSuggestSizes,
  AddCart: ProductInfoSuggestAddCart,
  Gallery: ProductInfoSuggestGallery,
}
